import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export async function getBESS({ id }: { id?: string }): Promise<
  | {
      id: string;
      name: string;
      mqttStatus: number;
      createdAt: string;
      updatedAt: string;
    }
  | undefined
> {
  if (!id) return undefined;

  try {
    const { data } = await client.get(`/bess/${id}`);

    return data.body;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useGetBESSQuery = (
  { enabled, id }: { enabled?: boolean; id?: string } = { enabled: true }
) => {
  return useQuery({
    queryKey: ['bess', id],
    queryFn: () => getBESS({ id }),
    retry: 1,
    enabled,
  });
};
